import { DataGrid, } from "devextreme-react";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDataSource } from "../../../contexts/dataSource";
import { useAuth } from "../../../contexts/auth";
import { getPropsDataGrid } from "../../../utils/default-props";
import { Column, ColumnChooser, FilterPanel, FilterRow, HeaderFilter, Lookup, RequiredRule, SearchPanel, Toolbar } from "devextreme-react/data-grid";
import { useScreenSize } from "../../../utils/media-query";
import { Item } from "devextreme-react/form";
import { getDataGridCustomToolbarCaption } from "../../../components/default-components/data-grid-custom-toolbar";
import { usePublicEvents } from "../../../contexts/public-events";
import { useNavigate } from "react-router-dom";


function LeaveList() {
    //#region useStates
    const [sizeParam, setSizeParam] = useState({})
    const [id, setId] = useState()
    //#endregion

    //#region hooks
    const { isXSmall, isLarge, isMedium } = useScreenSize();
    const { dataSourceHR } = useDataSource()
    const { user } = useAuth()
    const dataGridRef = useRef()
    const { setPublicAddEvent } = usePublicEvents()
    const navigate = useNavigate();
    //#endregion

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeeLeave`,
        insertUrl: "/api/EmployeeLeave/FormData"
    }), [user])

    const dbEmployes = useMemo(() => dataSourceHR({
        loadUrl: `/api/Employee/ComboList`,
        loadMode: "raw",

    }), [user])

    const dbLeaveType = useMemo(() => dataSourceHR({
        loadUrl: `/api/LeaveInfo`,
        loadMode: "raw"
    }), [user])

    useEffect(() => {
        if (isLarge || isMedium)
            setSizeParam({ width: 500, height: 600 })
        else
            setSizeParam({})
    }, [isLarge, isMedium])

    const dateEditorOption = {
        type: "datetime",
        // placeholder: "12/31/2018 00:00",
        showClearButton: true,
        //inputAttr=dataTimeLabel
        useMaskBehavior: true,
        // displayFormat="EEEE, d of MMM, yyyy HH:mm",
        displayFormat: "dd.MM.yyyy HH:mm",
        //dateSerializationFormat: "yyyy-MM-dd"

    }
    const dateTimeEditorOption = {
        type: "datetime",
        showClearButton: true,
        useMaskBehavior: true,
    }

    const leaveEditorOption = {
        dataSource: dbLeaveType,
        valueExpr: "id",
        displayExpr: "name",
        applyValueMode: "instantly",
        //onValueChanged: handleLeaveTypeChange,
    }

    const onFocusedRowChanged = (e) => {
        setId(e.component.option('focusedRowKey'));
    }

    const handleAdd = useCallback((e) => {
        navigate('/leave/leave-card')
    }, [])

    const handleEdit = useCallback((e) => {
        navigate(`/leave/leave-card/${id}`)
    }, [id])

    useEffect(() => {
        setPublicAddEvent(() => handleAdd)

        return () => {
            setPublicAddEvent(undefined)
        }
    }, [handleAdd])

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <DataGrid
                        ref={dataGridRef}
                        dataSource={dataSource}
                        {...getPropsDataGrid}
                        focusedRowKey={id}
                        onFocusedRowChanged={onFocusedRowChanged}
                        onCellDblClick={handleEdit}

                    //onInitNewRow={handleInitNewRow}
                    >
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <HeaderFilter />
                        <SearchPanel visible />
                        <ColumnChooser enabled />
                        {/* <KeyboardNavigation enterKeyAction={"moveFocus"} enterKeyDirection={"row"} /> */}
                        <Toolbar>
                            {getDataGridCustomToolbarCaption("İzin Listesi")}
                            <Item name="searchPanel" />
                            <Item name="columnChooserButton" />
                            <Item name="addRowButton" />
                        </Toolbar>

                        <Column dataField="employeeId" caption="Personel" >
                            <Lookup dataSource={dbEmployes} valueExpr="id" displayExpr="text" />
                            <RequiredRule />
                        </Column>
                        <Column dataField="leaveInfoId" caption="İzin Türü" >
                            <Lookup dataSource={dbLeaveType} valueExpr="id" displayExpr="name" />
                            <RequiredRule />
                        </Column>
                        <Column dataField="startDate" caption="İzin Başlangıç"
                            editorType="dxDateBox"
                            editorOptions={dateEditorOption}
                            dataType="datetime"
                            format="shortDateShortTime"
                        />

                        <Column dataField="endDate" caption="İzin Bitiş"
                            editorType="dxDateBox"
                            editorOptions={dateEditorOption}
                            dataType="datetime"
                            format="shortDateShortTime" />

                        <Column dataField="duration" caption="Süre" dataType="number" />
                        <Column dataField="returnToWorkDate" caption="İşbaşı Tarihi" dataType="date" editorType="dxDateBox" editorOptions={dateEditorOption} />
                        <Column dataField="explanation" caption="Açıklama" />
                        <Column dataField="address" caption="Adres" />
                        <Column dataField="standInEmployeeId" caption="Yerine Bakacak Personel">
                            <Lookup dataSource={dbEmployes} valueExpr="id" displayExpr="text" />
                            <RequiredRule />
                        </Column>
                    </DataGrid>
                    {/* <Button onClick={handleAdd}>Yeni Kayit</Button>
                    <Button onClick={handleEdit}>Düzenle</Button> */}
                </div>
            </div>

        </React.Fragment >
    )
}

export default React.memo(LeaveList)